// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gOQX","select":"styles_select__12u-I"};